import React, { createContext, useEffect } from "react";
import "./App.css";
import "./styles/commonFontSizes.css";
import "./styles/commonColors.css";
import "./styles/commonStyle.css";
import "./styles/commonFontWeights.css";
import { Outlet, useNavigate, useSearchParams } from "react-router-dom";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import Loader from "./component-lib/Molecules/loader/Loader";
import EventEMRResponsiveAppBar from "./component-lib/Organisms/header/Header";
import { useDispatch, useSelector } from "react-redux";
import { componentKey, setIsLoggedIn } from "./screens/login-screen/LoginSlice";
import { getLoginUserData, getLoginUserId } from "./utils/getToken";
import { refreshToken } from "./screens/login-screen/LoginSaga";

function App() {
  const parseLoginUserId: any = getLoginUserId();
  const loginUserId = JSON.parse(parseLoginUserId);
  const dispatch = useDispatch();
  const path = window?.location?.pathname?.split("/")[1];
  const { isLoggedIn, isTokenRefreshing } = useSelector((state: any) => state[componentKey]);
  const [searchParams] = useSearchParams();

  useEffect(() => {
    let tokenFromUrl = searchParams.get("refreshToken");
    const facilityIdFromUrl = searchParams.get("facilityId");

    if (tokenFromUrl) {
      if (tokenFromUrl.startsWith('"') && tokenFromUrl.endsWith('"')) {
        tokenFromUrl = tokenFromUrl.slice(1, -1);
      }

      if (facilityIdFromUrl) {
        localStorage.setItem("facilityId", facilityIdFromUrl);
        sessionStorage.setItem("facilityId", facilityIdFromUrl);
      }

      dispatch(refreshToken(tokenFromUrl));
    }
  }, [searchParams, dispatch]);

  const loginUserData = getLoginUserData();
  const b: { email?: string } | null = loginUserData
    ? JSON.parse(loginUserData)
    : null;
  const navigate = useNavigate();

  useEffect(() => {
    if (b?.email) {
      dispatch(setIsLoggedIn(true));
    }
  }, [b?.email, navigate, path, isLoggedIn, dispatch]);

  useEffect(() => {
    const tokenFromUrl = searchParams.get("refreshToken");
    const facilityIdFromUrl = searchParams.get("facilityId");
    
    // Only redirect to dashboard if user just completed token authentication
    if (isLoggedIn && b?.email && tokenFromUrl && path !== 'dashboard') {
      navigate('/dashboard');
    }
  }, [isLoggedIn, b?.email, path, navigate, searchParams]);

  // Show only loader when token is being refreshed
  if (isTokenRefreshing) {
    return <Loader />;
  }

  return (
    // App shell: a flex column anchored to the DYNAMIC viewport height.
    // 100dvh (unlike 100vh) excludes mobile browser chrome, and the header
    // keeps its natural height instead of being assumed to be 90px — so no
    // magic numbers and nothing spills below the fold on iPad.
    <div className="flex flex-col h-[100dvh]">
      {isLoggedIn && (
        <EventEMRResponsiveAppBar
          handlePageChange={(page: any) => {
            switch (page) {
              case "Dashboard":
                navigate("/dashboard");
                break;
              case "Patient":
                navigate("/patient");
                break;
              case "Settings":
                navigate("/settings");
                break;
              case "Tasks":
                navigate("/tasks");
                break;
              case "Reports":
                navigate("/reports");
                break;
              case "Contact-directory":
                navigate("/contact-directory");
                break;
              case "Inventory":
                navigate("/inventory");
                break;
              case "Documents":
                navigate("/documents");
                break;
              case "Unsigned-visits":
                navigate("/unsigned-visits");
                break;
              default:
                console.warn("Unknown page:", page);
                break;
            }
          }}
        />
      )}
      {/* Takes whatever height is left under the header. min-h-0 lets it
          shrink so its child scrolls instead of overflowing the page. */}
      <main
        className="flex-1 min-h-0 flex flex-col"
        style={{ background: "#F1F1F1" }}
      >
        <div className="flex-1 min-h-0 flex flex-col">
          <Outlet />
        </div>
      </main>
      <ToastContainer
        position="top-right"
        autoClose={3000}
        hideProgressBar={true}
      />
      <Loader />
    </div>
  );
}

export default App;
